import React from 'react';
import ReactDOM from 'react-dom/client';
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { I18nextProvider } from 'react-i18next';
import App from './App';
import { AuthProvider } from './state/AuthContext';
import { ToastProvider } from './state/ToastContext';
import { ConfirmProvider } from './state/ConfirmContext';
import { ThemeModeProvider } from './state/ThemeContext';
import { i18n } from './i18n';

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeModeProvider>
        <CssBaseline />
        <AuthProvider>
          <I18nextProvider i18n={i18n}>
            <ToastProvider>
              <ConfirmProvider>
                <BrowserRouter>
                  <App />
                </BrowserRouter>
              </ConfirmProvider>
            </ToastProvider>
          </I18nextProvider>
        </AuthProvider>
      </ThemeModeProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
